<template>

    <v-layout justify-center>

        <v-dialog v-model="loading" persistent max-width="30%">

            <v-container align-content-center grid-list-md class="centered-dialog">

               <v-layout style="min-height: 200px;" column justify-center align-center>

                    <h1> {{ message }}</h1>

                    <v-progress-circular color="white" indeterminate :size="90" :width="15" />

               </v-layout>

            </v-container>

        </v-dialog>

    </v-layout>

</template>

<script>
export default {
    computed: {
        loading() {
            return this.$store.getters.isLoading;
        },

        message() {
            return this.$store.getters.message;
        },
    },
};
</script>
<style scoped>
  .centered-dialog,
  .v-dialog.centered-dialog
 {
    background: #111213ad;
    box-shadow: none;
    border-radius: 6px;
    width: auto;
    color: rgb(36, 33, 33);
  }

  .container{
      margin-bottom: 0 !important;
  }

  h1{
      color: white;
  }
</style>
